import { motion } from "framer-motion";
import { PROCESS } from "@/data/site";

export default function Process() {
  return (
    <section id="process" data-testid="process-section" className="relative py-24 md:py-40 border-t border-brand-border">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-24">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-20">
          <div>
            <p className="eyebrow mb-6">(04) — Our process</p>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight font-medium max-w-[15ch]">
              Six steps to <span className="italic text-brand-brown">compounding growth</span>.
            </h2>
          </div>
          <p className="max-w-md text-brand-charcoal/70 text-base md:text-lg leading-relaxed">
            The process is deliberately simple. Rigour lives inside each step, not in the number of them.
          </p>
        </div>

        {/* Timeline */}
        <div className="relative">
          <div aria-hidden className="absolute left-8 md:left-1/2 top-0 bottom-0 w-px bg-brand-border md:-translate-x-1/2" />

          <div className="space-y-16 md:space-y-24">
            {PROCESS.map((p, i) => (
              <motion.div
                key={p.step}
                data-testid={`process-step-${i}`}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 0.8, ease: [0.19, 1, 0.22, 1] }}
                className={`relative flex flex-col md:flex-row items-start gap-8 md:gap-16 pl-20 md:pl-0 ${
                  i % 2 === 0 ? "md:justify-start" : "md:flex-row-reverse md:justify-start"
                }`}
              >
                {/* Node */}
                <div className="absolute left-0 md:left-1/2 md:-translate-x-1/2 top-0 w-16 h-16 rounded-full bg-brand-beige border border-brand-border flex items-center justify-center">
                  <span className="font-display text-xl text-brand-brown">{p.step}</span>
                </div>

                <div className="md:w-1/2" />
                <div className={`md:w-1/2 ${i % 2 === 0 ? "md:pl-24" : "md:pr-24 md:text-right"}`}>
                  <h3 className="font-display text-3xl md:text-4xl leading-tight mb-3 font-medium">{p.title}</h3>
                  <p className="text-brand-charcoal/70 leading-relaxed max-w-md">
                    {p.desc}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
